import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import './TpsBrand.css';
export const TPS_NEON_MARK = '/assets/tps/variants/tps-03-neon-rosso-v2/app-512.png';

// Preserve the official guide wordmark, including its STUDIO rules and payoff.
// The viewport exposes only the lettering; the old monogram stays outside it.
export default function TpsBrand({className = ''}) {
  useUiLanguage();
  return <span className={`tps-brand-lockup ${className}`} role="img" aria-label={tr("Tattoo Pro Studio — Manage, Organize, Grow")}>
    <img className="tps-brand-monogram" src={TPS_NEON_MARK} width="512" height="512" alt="" />
    <span className="tps-brand-wordmark" aria-hidden="true">
      <img className="tps-wordmark-dark" src="/assets/tps/logo/tps-logo-horizontal-dark.png" width="1400" height="400" alt="" />
      <img className="tps-wordmark-light" src="/assets/tps/logo/tps-logo-horizontal-light.png" width="1400" height="400" alt="" />
    </span>
  </span>;
}
